import { memo } from "react"

export const PrivacyPolicyApp = memo(() => {
  return (
    <div>
      <h2>Política Privacidade</h2>
      <br />
      <div>A sua privacidade é importante para nós. É política do MR Critic respeitar a sua privacidade em relação a qualquer informação sua que possamos coletar no app MR Critic, e outros sites que possuímos e operamos.</div>
      <br />
      <div>Solicitamos informações pessoais apenas quando realmente precisamos delas para lhe fornecer um serviço. Fazemo-lo por meios justos e legais, com o seu conhecimento e consentimento. Também informamos por que estamos coletando e como será usado.</div>
      <br />
      <div>Apenas retemos as informações coletadas pelo tempo necessário para fornecer o serviço solicitado. Quando armazenamos dados, protegemos dentro de meios comercialmente aceitáveis para evitar perdas e roubos, bem como acesso, divulgação, cópia, uso ou modificação não autorizados.</div>
      <br />
      <div>Não compartilhamos informações de identificação pessoal publicamente ou com terceiros, exceto quando exigido por lei.</div>
      <br />
      <div>O nosso site pode ter links para sites externos que não são operados por nós. Esteja ciente de que não temos controle sobre o conteúdo e práticas desses sites e não podemos aceitar responsabilidade por suas respectivas políticas de privacidade.</div>
      <br />
      <div>Você é livre para recusar a nossa solicitação de informações pessoais, entendendo que talvez não possamos fornecer alguns dos serviços desejados.</div>
      <br />
      <div>O uso continuado de nosso site será considerado como aceitação de nossas práticas em torno de privacidade e informações pessoais. Se você tiver alguma dúvida sobre como lidamos com dados do usuário e informações pessoais, entre em contacto connosco.</div>

      <br /><br />

      <b>Compromisso do Usuário</b>
      <br /><br />
      O usuário se compromete a fazer uso adequado dos conteúdos e da informação que o MR Critic oferece no app e com caráter enunciativo, mas não limitativo:
      <br /><br />
      A - Não se envolver em atividades que sejam ilegais ou contrárias à boa fé a à ordem pública;
      <br />
      B -  Não difundir propaganda ou conteúdo de natureza racista, xenofóbica, casas de apostas online (ex.: ), jogos de sorte e azar, qualquer tipo de pornografia ilegal, de apologia ao terrorismo ou contra os direitos humanos;
      <br />
      C -  Não causar danos aos sistemas físicos (hardwares) e lógicos (softwares) do MR+, de seus fornecedores ou terceiros, para introduzir ou disseminar vírus informáticos ou quaisquer outros sistemas de hardware ou software que sejam capazes de causar danos anteriormente mencionados.
      <br />
      <br />
      Mais informações
      <br />
      Esperemos que esteja esclarecido e, como mencionado anteriormente, se houver algo que você não tem certeza se precisa ou não, geralmente é mais seguro deixar os cookies ativados, caso interaja com um dos recursos que você usa em nosso site.
      <br />
      <br />
      <div>Esta política é efetiva a partir de Agosto/2022.</div>
    </div>
  );
});
